module.exports = __webpack_public_path__ + "static/media/sf-test-18.ba151c8e.mp3";